const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;
// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Helper function to make API requests
const apiRequest = async (endpoint, options = {}) => {
  const token = getAuthToken();
  
  // Only set Content-Type if not explicitly removed and body exists
  const defaultHeaders = {};
  if (!options.skipContentType && options.body) {
    defaultHeaders['Content-Type'] = 'application/json';
  }
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  };
  
  // Remove skipContentType from config as it's not a valid fetch option
  delete config.skipContentType;

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'An error occurred' }));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Login API
export const login = async (email, password) => {
  // Encode email and password for URL query parameters
  const queryParams = new URLSearchParams({
    username: email,
    password: password
  });
  
  return apiRequest(`/api/login?${queryParams.toString()}`, {
    method: 'GET',
    skipContentType: true, // Don't set Content-Type since we're not sending a body
  });
};

// Upload files API
export const uploadFiles = async (files, categoryId) => {
  const formData = new FormData();
  
  files.forEach((fileItem) => {
    formData.append('files', fileItem.file);
  });

  // Get userId from localStorage
  const userId = localStorage.getItem('userId');
  
  // Append categoryId and userId to formData
  if (categoryId) {
    formData.append('tag', categoryId);
    formData.append('title', categoryId);
  }
  if (userId) {
    formData.append('user_id', userId);
  }

  console.log(formData);
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/api/upload`, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Upload failed' }));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  return data;
};

// Get user profile API
export const getUserProfile = async (userId) => {
  const queryParams = new URLSearchParams({
    user_id: userId
  });
  
  const response = await apiRequest(`/api/user?${queryParams.toString()}`, {
    method: 'GET',
  });
  console.log(response);
  return response;
};

export default {
  login,
  uploadFiles,
  getUserProfile,
};

